(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Accounts.ACM",
                {
                    url: "/ACM",
                    component: "acmAccounts",
                    data: {
                        pageTitle: "ACM Accounts"
                    },
                    onEnter: [
                        "$state", "figXref", "parentFigXrefs", function ($state, figXref, parentFigXrefs) {
                            if (!figXref && parentFigXrefs.length === 0)
                                $state.go("Home.401");
                        }
                    ]
                });
        }
    ]);

    app.component("acmAccounts",
        {
            templateUrl: "/App/Accounts/ACMAccounts/acm-accounts.html",
            controller: acmAccountsController
        });

    acmAccountsController.$inject = ["_", "$q", "$scope", "$mdDialog", "$rootScope", "caseApi", "investmentAccountApi", "xrefAccountApi", "$timeout", "$state", "statusTypes", "clientApi", "externalAccountApi"];
    function acmAccountsController(_, $q, $scope, $mdDialog, $rootScope, caseApi, investmentAccountApi, xrefAccountApi, $timeout, $state, statusTypes, clientApi, externalAccountApi) {
        var $ctrl = this;

        var errorAlert = $mdDialog.alert({
            focusOnOpen: false,
            title: "An error retrieving accounts occured.",
            textContent: "Please refresh the page and try again.",
            ariaLabel: "Error alert",
            ok: "Close",
            skipHide: true
        });

        ng.extend($ctrl,
            {
                committing: false,
                connecting: 0,
                clientCases: {},
                caseAccounts: {},
                sortBy: { col: "Client", asc: true },
                ui: { loading: true },
                selectedOptions: $ctrl.acmAccounts,
                accountsForCase: accountsForCase,
                commitChanges: commitChanges,
                searchClients: searchClients,
                toggleSort: toggleSort,
                selectClient: selectClient
            });

        function searchClients(term) {
            return clientApi.searchClients(term).then(function (results) {
                ng.forEach(results, function (row) {
                    row.Term = row.Person.FirstName + " " + row.Person.LastName;
                });

                results.push({ Term: "Create " + term, Name: term, Type: "NewClient" });
                return results;
            });
        }

        function selectClient(searchClient, account, $event) {
            if (!!searchClient) {
                if (searchClient.Type === "NewClient") {
                    var firstSpaceIndex = searchClient.Name.indexOf(" ");
                    var lastSpaceIndex = searchClient.Name.lastIndexOf(" ");
                    var nameLength = searchClient.Name.length;

                    var client = {
                        Person: {
                            FirstName: searchClient.Name.substring(0,
                                firstSpaceIndex !== -1 ? firstSpaceIndex : nameLength),
                            MiddleName: lastSpaceIndex !== firstSpaceIndex
                                ? searchClient.Name.substring(firstSpaceIndex + 1, lastSpaceIndex)
                                : null,
                            LastName: searchClient.Name.substring(
                                lastSpaceIndex !== -1 ? lastSpaceIndex + 1 : nameLength,
                                nameLength)
                        }
                    }
                    account.searchText = "";

                    return openAddClient(client, account, $event).then(function (response) {
                        searchClient = response;
                        account.searchText = client.Person.FirstName + " " + client.Person.LastName;
                        return getClientCases(searchClient, account);
                    });
                } else {
                    return getClientCases(searchClient, account);
                }
            }
        }

        function openAddClient(client, account, $event) {
            var alert = $mdDialog.alert({
                focusOnOpen: false,
                templateUrl: "/App/Accounts/AddAccountClient/addaccountclient-template.html",
                controller: "addAccountClientController",
                controllerAs: "$ctrl",
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    client: client
                }
            });

            return $mdDialog.show(alert).then(function (response) {
                return response;
            });
        }

        function getClientCases(client, account) {
            if (!client) return $q.when();

            account.NewClient = client;

            if (!client.Id || $ctrl.clientCases[client.Id]) return $q.when();

            $ctrl.clientCases[client.Id] = [];
            return caseApi.getClientCases(client.Id).then(function (response) {
                    $ctrl.clientCases[client.Id].push.apply($ctrl.clientCases[client.Id], response);
                },
                function() {
                    $ctrl.clientCases[client.Id] = [];
                });
        }

        function accountsForCase(caseId) {
            if (!caseId || $ctrl.caseAccounts[caseId]) return $q.when();

            $ctrl.caseAccounts[caseId] = [];

            return investmentAccountApi.getCaseInvestmentAccounts(caseId).then(function (accounts) {
                $ctrl.caseAccounts[caseId].push.apply($ctrl.caseAccounts[caseId], accounts);
            }, function () { $ctrl.caseAccounts[caseId] = []; });
        }

        function commitChanges(accounts) {
            if (!accounts || accounts.length === 0) return $q.when();

            accounts = _.filter(accounts, function (account) {
                return account.Checked && !account.AccountId;
            });

            if (accounts.length === 0) return $q.when();

            $ctrl.committing = true;

            ng.forEach(accounts, function (a) {
                a.CurrentStatus = statusTypes.toShort(a.CurrentStatus);
            });

            var batches = _.chunk(_.map(accounts, function (acc) {
                if (acc.NewClient) acc.Client.Id = acc.NewClient.Id;
                if (acc.NewCase && acc.NewCase.Id) acc.CaseId = acc.NewCase.Id;
                if (acc.NewAccount && acc.NewAccount.Id) acc.AccountId = acc.NewAccount.Id;

                return acc;
            }), 25);

            return _.reduce(batches, function (promise, batch) {
                return promise.then(function () {
                    return $timeout(function () {
                        return xrefAccountApi.addInvestments(batch).then(function (response) {
                            ng.forEach(response, function (account) {
                                var a = _.find($ctrl.acmAccounts, function (acc) {
                                    return acc.AcmAccountGuid === account.AcmAccountGuid;
                                });

                                if (a) {
                                    a.AccountId = account.AccountId;
                                    a.CaseId = account.CaseId;
                                    a.Client.Id = account.Client.Id;
                                }
                            });
                        });
                    }, 1000);
                });
            }, $q.when()).then(function () {
                $ctrl.committing = false;
                $ctrl.connecting = 0;
            });
        }

        function toggleSort(col) {
            if ($ctrl.sortBy.col === col)
                $ctrl.sortBy.asc = !$ctrl.sortBy.asc;
            else
                $ctrl.sortBy = { col: col, asc: true };

            return refreshList();
        }

        function refreshList() {
            $ctrl.acmAccounts = _.sortBy($ctrl.acmAccounts,
                function (account) {
                    switch ($ctrl.sortBy.col) {
                        case "Advisor":
                            return [account.Advisor.FirstName, account.Advisor.LastName];
                        case "Client":
                            return [account.Client.FirstName, account.Client.LastName];
                        case "AccountNumber":
                        case "AccountType":
                        case "Custodian":
                        case "Model":
                        default:
                            return account[$ctrl.sortBy.col];
                    }
                });

            if (!$ctrl.sortBy.asc) $ctrl.acmAccounts = $ctrl.acmAccounts.reverse();
        }

        $ctrl.$onInit = () => {
            externalAccountApi.getAcmAccounts().then(function (accounts) {
                $ctrl.acmAccounts = ng.forEach(accounts, function (account) {
                    ng.extend(account,
                        {
                            Checked: !!account.AccountId
                        });

                    account.CurrentStatus = statusTypes.toLong(account.CurrentStatus);

                    return account;
                });
                refreshList();

                $ctrl.ui.loading = false;
            }).catch(function (error) {
                $ctrl.ui.loading = false;
                $mdDialog.show(errorAlert);
            });
        }
    }

})(window.app, window.angular); //jshint ignore:line